<template>
  <div class="page-order-detaul-bom" >
    <div class="page-order-detail-bottom">
      <div class="page-order-detail-bottom-content" :style="{ height: 'calc( 100% - 70px)' }" v-loading="pageLoading">
        <template>
          <!-- <iframe class="page-card-iframe" ref="iframeRef" v-if="isShow" :src="'https://visa-application-form.sport-syy.com' +'&terminal=PC'"
                                frameborder="0" scrolling="auto" :style="{height: '100%'}"></iframe> -->
          <!-- .replace('https://visa-application-form.sport-syy.com', 'http://localhost:8081')  -->
          <iframe v-if="isShow" class="page-card-iframe" ref="iframeRef" frameborder="0" scrolling="auto" style="height: 100%;"></iframe>
          <!-- v-if="isShow" :src="'https://visa-application-form.sport-syy.com&terminal=PC&'+ applicationForm.userId" -->
        </template>
        <!-- <div v-if="!orderDetail.visaDetail && orderDetail.visaDetail.visa.isTable" class="no-iframe">
          <img src="@/assets/images/orderCenter/empty2.png" alt="暂无数据" style="width: 162px; height: 147px" />
        </div> -->
      </div>
      <div class="page-rder-detail-bottom-btn">
        <div style="display: flex; align-items: center;">
          <!-- class="default" -->
          <el-button type="primary" v-if="orderDetail.order.autocommit" :disabled="submitLoading || applicationForm.status == 10 || applicationForm.taskTable != 100" :loading="submitLoading || applicationForm.status == 10" @click="clickSubmit" :style="applicationForm.status == 14 ? 'padding: 0' : '' ">
            <span v-if="applicationForm.status == 10">提交中</span>
            <span v-else-if="applicationForm.status == 20">重新提交</span>
            <span v-else-if="applicationForm.status == 12">前往支付</span>
            <span v-else-if="applicationForm.status == 16">下载签证页</span>
            <el-upload ref="uploadRef" @click.stop="" v-else-if="applicationForm.status == 14" action="" :http-request="uploadVisapage">
              <el-button type="primary"> <i class="iconfont icon-shangchuan visa-icon" style="color: #ffffff">上传签证页</i> </el-button>
            </el-upload>
            <span v-else>提交到大使馆网站</span>
          </el-button>

          <el-tooltip v-if="applicationForm.status == 20" :content="applicationForm.latestStatus">
            <div style="color: red;width: 300px; word-break: keep-all; text-overflow: ellipsis; overflow: hidden;line-height: 15px;">
              {{ applicationForm.latestStatus }}
            </div>
          </el-tooltip>
        </div>
        <div>
          <span style="
                  font-size: 16px;
                  color: #0094e8;
                  margin-right: 32px;
                  cursor: pointer;
                " @click="reload">刷新1</span>
          <!--  class="default" -->
          <el-button type="primary" plain v-if="applicationForm.canUpdateInfo" 
          @click="iframeUpdate">修改</el-button>
          <el-button type="primary" :disabled="[8, 10, 14, 16, 12].indexOf(applicationForm.status) != -1
                " @click="iframeSubmit">保存</el-button>
          <!--  class="text2" -->
          <el-button type="danger" :disabled="[8, 10, 14, 16, 12].indexOf(applicationForm.status) != -1
                " style="margin-right: 6px" @click="delUser">删除</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'informationsTable',
  props: {

    orderDetail: {
      type: Object,
      default: () => { }
    },
    applicationForm: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      pageLoading: false,
      submitLoading: false
    }
  },
  watch: {
    applicationForm: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.pageLoading = true;
          
          // let applicationForm = `https://visa-application-form.sport-syy.com/ThailandArrivalCard?passengerId=61897&secretkey=06925398-4162-4537-85c7-42aaa4d1958f&r=0&s=16`
          // this.$refs.iframeRef.contentWindow.location.replace(
          //   applicationForm + '&terminal=PC&' + val.userId
          // );
          // this.iframeUrl = applicationForm + '&terminal=PC&' + val.userId
          
          this.isShow = false;
          // 使用$nextTick确保iframe已销毁
          this.$nextTick(() => {
            
            setTimeout(() => {
              this.pageLoading = false;
            }, 2000);

            this.isShow = true;
            // 再设置新的url，触发iframe重建
            this.iframeUrl = val.applicationForm + "&terminal=PC&v=" + new Date().getTime()
          });

        }
 
      },
    },
  },
  methods: {
    clickSubmit() {
      // autoSubmitStatus-1时就是重新提交不需要再次支付，直接提交
      if (
        this.applicationForm.status == 20 &&
        this.applicationForm.autoSubmitStatus == -1
      ) {
        // 重新提交
        this.inpuSubmit();
      } else if (this.applicationForm.status == 12) {
        this.openPay(this.applicationForm);
      } else if (this.applicationForm.status == 16) {
        window.open(this.applicationForm.visaPage);
      } else if (this.applicationForm.status == 14) {
        // 上传签证页
        // this.$refs.uploadRef.$el.querySelector('input').click()
      } else {
        this.isBatch = false;
        // 选择支付方式提交大使馆
        this.submitApplicationShow = true;

        this.tjShow = false;
        this.dowmShow = false;
      }
    },
    inpuSubmit(payType) {
      if (this.submitLoading) {
        return;
      }
      this.submitLoading = true;
      // 备份操作申请人信息
      let applicationFormCopy = JSON.parse(JSON.stringify(this.applicationForm))
      batchsubmitapplicant({
        payType,
        orderApplicantIds: [this.applicationForm.id],
      })
        .then((res) => {
          this.submitLoading = false;

          if (res.data[0].successful) {
            this.$message({
              message: "提交成功！",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data[0].msg,
              type: "warning",
            });
          }
          sessionStorage.removeItem("km_userId");
          //this.orderdetailFn();
          setTimeout(() => {
            this.queryorderapplicantsFn();
          }, 3800);
          let findIndex = this.userList.findIndex((item) => {
            return item.id == applicationFormCopy.id;
          });
          if (findIndex > -1) {
            this.userList[findIndex].status = this.submitIngStatus;
            this.userList[findIndex] = { ...this.userList[findIndex] };
            this.userList = [...this.userList];
          }
          applicationFormCopy.status = this.submitIngStatus;
          // 提交中状态轮询查询订单状态
          this.clickApplicantStatus(applicationFormCopy);
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },

    uploadVisapage() {

    },
    delUser() {

    },

    reload() {
      this.isShow = false;
      this.$nextTick(() => {
         this.isShow = true;
      })
    },
    iframeSubmit() {
      this.$refs.iframeRef.contentWindow.postMessage(this.userId, "*");
    },
    iframeUpdate() {
      this.$refs.iframeRef.contentWindow.postMessage({
        type: "update",
        passengerId: this.userId
      }, "*");
    },
  }
}
</script>

<style lang="scss" scoped>
.page-order-detaul-bom {
  width: 100%;
  display: inline-flex;
  justify-content: center;
  height: calc(100% - 110px);

  .page-order-detail-bottom {
    width: 750px;
    // height: 1107px;
    // background: #FFF;

    .page-order-detail-bottom-title {
      width: 100%;
      height: 64px;
      background: #fff8ee;
      font-size: 14px;
      color: #ff9d3d;
      padding: 12px;
      box-sizing: border-box;
      margin-bottom: 30px;
    }

    .page-order-detail-bottom-content {
      position: relative;
      // height: 980px;

      // background: rgb(138, 115, 115);
      width: 100%;

      iframe {
        flex: 1;
        width: 784px;
        height: 628px;
        font-size: 16px;
        body {
            font-size: 16px;
        }
        .countryContainer {
          background: #fff !important;
        }
      }

      .no-iframe {
        position: absolute;
        top: 64px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #6666;
        font-size: 18px;
        border-radius: 12px;
        background-color: #f5f5f5;
      }
    }

    .page-rder-detail-bottom-btn {
      box-shadow: 0px -3px 12px 1px rgba(102, 102, 102, 0.1);
      flex: 1;
      height: 61px;
      line-height: 61px;
      text-align: right;
      display: flex;
      justify-content: space-between;
      padding: 0 10px;
      background: #fff;
      width: auto !important;
    }
  }
  // background: #FFF;
}
</style>